import { useState, useEffect, useCallback } from 'react';
import { useAccount, useSignMessage, useChainId } from 'wagmi';
import { notifications } from '@mantine/notifications';
import { getNonce, createMessage, verify, getAccessToken } from '../authAdapter';

export function useAprAuth() {
  const { address, isConnected } = useAccount();
  const chainId = useChainId();
  const { signMessageAsync } = useSignMessage();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  const checkAuth = useCallback(() => {
    if (address) {
      const token = getAccessToken(address);
      setIsAuthenticated(!!token);
    } else {
      setIsAuthenticated(false);
    }
    setIsChecking(false);
  }, [address]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async () => {
    if (!address || !isConnected) {
        return;
    }

    setIsAuthenticating(true);
    try {
      const nonce = await getNonce(address);
      const message = createMessage({ nonce, address, chainId });
      const signature = await signMessageAsync({ message });
      const success = await verify({ message, signature, address });

      if (success) {
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error('Login failed', error);
      notifications.show({
        title: 'Authentication Required',
        message: 'Please sign the message to verify your account ownership.',
        color: 'yellow',
      });
    } finally {
      setIsAuthenticating(false);
    }
  };

  return {
    isAuthenticated,
    isAuthenticating,
    isChecking,
    login,
    checkAuth
  };
}
